module.exports = __webpack_public_path__ + "img/sign.8a8a9cd6.png";